"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanTypeEnum = exports.PaymentPlanStatusEnum = void 0;
var PaymentPlanStatusEnum;
(function (PaymentPlanStatusEnum) {
    PaymentPlanStatusEnum["ACTIVE"] = "active";
    PaymentPlanStatusEnum["INACTIVE"] = "inactive";
})(PaymentPlanStatusEnum = exports.PaymentPlanStatusEnum || (exports.PaymentPlanStatusEnum = {}));
var PaymentPlanTypeEnum;
(function (PaymentPlanTypeEnum) {
    PaymentPlanTypeEnum["NO_PLAN"] = "no_plan";
    PaymentPlanTypeEnum["PAYMENT_DATE"] = "payment_date";
    PaymentPlanTypeEnum["SCHEDULE"] = "schedule";
    PaymentPlanTypeEnum["ROLLING"] = "rolling";
    PaymentPlanTypeEnum["CUSTOM"] = "custom";
})(PaymentPlanTypeEnum = exports.PaymentPlanTypeEnum || (exports.PaymentPlanTypeEnum = {}));
//# sourceMappingURL=payment-plan.enums.js.map